import { AdminService } from "../admin.service";
import { ParentServiceInterface } from "./interface";
import { NextSessionResponse } from "../remote/model";
class ParentServiceClass extends AdminService implements ParentServiceInterface {
  getChildren<T>(): Promise<T> {
    return this.get(`parents/gsconnect-children`);
  }
  getGSConnectAccess(): Promise<boolean> {
    return this.get(`parents/gsconnect-access`);
  }
  getStudentNextSessionFromAdmin(studentIds: string[]): Promise<Array<NextSessionResponse>> {
    return this.create(`schoolclass/next-session`, studentIds);
  }
}

export const ParentService = new ParentServiceClass();
